import React from "react";
import { HeroReuse } from "../../components/common/HeroReuse";
import articleImg from "../../assets/article5.png"
import ArticleContent from "../../components/sections/blog/ArticleContent";
import { articleContent5 } from "../../constants/data";
import RequestDemo from "../../components/common/RequestDemo";

const ArticleFourth = ({title, description }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-[2.25rem] sm:gap-16 lg:gap-0">
      <HeroReuse
        Title="Why Manual Regulatory Compliance Processes Are Draining Your Budget"
        Description="Manual compliance workflows, paperwork, and license management are silently increasing your costs. Here’s how automating regulatory compliance can help you save time and money."
        date="2 July 2025"
        imgUrl={articleImg}
        titleClass={'tracking-tight pt-3 md:pt-8'}
      />
      <ArticleContent content={articleContent5} toolsClass="font-bold text-darkGray"/>
      <RequestDemo />
    </div>
  );
};

export default ArticleFourth;
